module.exports = __webpack_public_path__ + "img/Rectangle 55(1).50fe3bb6.png";